import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, Game } from '../api/rest';
import { relativeTime } from '../lib/time';

interface Result {
  nickname: string;
  finalScore: number;
}

export function History() {
  const [games, setGames] = useState<Game[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [openId, setOpenId] = useState<string | null>(null);
  const [results, setResults] = useState<Record<string, Result[]>>({});

  useEffect(() => {
    api
      .listGames()
      .then((gs) => setGames(gs.filter((g) => g.status === 'finished')))
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load'));
  }, []);

  const toggle = async (id: string) => {
    if (openId === id) {
      setOpenId(null);
      return;
    }
    setOpenId(id);
    if (!results[id]) {
      const detail = await api.getGame(id);
      const rs = (detail.results as Result[]).sort((a, b) => b.finalScore - a.finalScore);
      setResults((r) => ({ ...r, [id]: rs }));
    }
  };

  return (
    <div className="stack">
      <div className="rowbetween">
        <h1>Past games</h1>
        <Link to="/admin/games" className="ghost">← Games</Link>
      </div>
      {error && <div className="banner error">{error}</div>}
      {games.length === 0 ? (
        <p className="muted">No finished games yet.</p>
      ) : (
        <div className="card">
          <ul className="gamelist">
            {games.map((g) => (
              <li key={g.id} className="historyrow">
                <button className="linkish" onClick={() => toggle(g.id)}>
                  {openId === g.id ? '▾' : '▸'} <span className="code">{g.code}</span>
                  <span className="muted small"> {relativeTime(g.createdAt) ?? ''}</span>
                </button>
                {openId === g.id && (
                  <ol className="scores">
                    {(results[g.id] ?? []).map((r, i) => (
                      <li key={i}><span>{r.nickname}</span><span className="points">{r.finalScore}</span></li>
                    ))}
                    {(results[g.id] ?? []).length === 0 && <li className="muted">No players.</li>}
                  </ol>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
